// extracted by mini-css-extract-plugin
module.exports = {"background":"AllPokemonCards_background__3BE0U","addedBackground":"AllPokemonCards_addedBackground__3qsCe","container":"AllPokemonCards_container__3O290"};